module.exports = __webpack_public_path__ + "img/product-penjaminan-konstruksi-barang-jasa.a37a7311.jpeg";